import { TransferField } from './Components'

export const renderElements = (elements, stateProp, readOnly, i, p) =>
  Object.keys(elements).sort((a, b) => elements[a].order - elements[b].order).map((key) => {
    const event = elements[key]
    return <TransferField state={stateProp} item={event} key={key} count={i} count2={p} readOnly={readOnly} width={event.width} />
  })
